export default "__VITE_ASSET__a2c25ea8__"